/**
 * example Message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645478421577,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"triggerMin":4,"triggerHour":3},"triggerPrice":null,"tradeDirection":null,"tacticName":"FLATTEN_BEFORE_MARKET_CLOSE","symbol":"XYZ"},
	"date": "2022-02-21T16:20:22.154-0500",
	"timestamp": "1645478422156"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) triggerHour
 * 2) triggerMin
 */
export function flattenBeforeMarketClosedParser(pluginTemplate) {
    const parsedObject = {
        triggerHour: null,
        triggerMin: null
    }
    if(pluginTemplate) {
        parsedObject.triggerHour=pluginTemplate.triggerHour;
        parsedObject.triggerMin=pluginTemplate.triggerMin;
    }
    return parsedObject;
}